import { Alert, Box, Button, Typography } from '@mui/material';
import Paper from 'components/paper';
import React from 'react';
import { FormattedMessage } from 'react-intl';

type Props = {
  onRetry: () => void;
};

const GlobalErrorFallback: React.FC<Props> = ({ onRetry }) => {
  return (
    <Paper transparent sx={{ p: 6 }}>
      <Box display="flex" justifyContent="center">
        <Box maxWidth={900} width="100%">
          <Alert
            severity="error"
            action={
              <Button color="inherit" size="small" onClick={onRetry}>
                <FormattedMessage id="errorBoundary.retry" />
              </Button>
            }>
            <Typography variant="body1" fontWeight={700}>
              <FormattedMessage id="errorBoundary.title" />
            </Typography>
            <Typography variant="body2">
              <FormattedMessage id="errorBoundary.message" />
            </Typography>
          </Alert>
        </Box>
      </Box>
    </Paper>
  );
};

export default GlobalErrorFallback;